import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import styled from 'styled-components';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Input from '@material-ui/core/Input';
import { Colors, Metrics } from '../../themes';
// import { StyledComponents } from '../../themes'; // merge to above line when implementing avatars
import SvgIcon from '../../icons/SvgIcon';
import clsx from 'clsx';

// const { LogoCircle, EmptyCircle } = StyledComponents; // will be used if implementing avatars

const StyledNameDropdown = styled.div`
  display: flex;
  flex-direction: row;
  padding-bottom: 10px;
`;

const useStyles = makeStyles((theme) => ({
  logoAndDropDownContainerRow: {
    display: 'flex',
    flexDirection: 'row',
    paddingBottom: 10,
  },
  formContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    color: Colors.white,
  },
  inputSelect: {
    textAlign: 'right',
    paddingLeft: 10,
    color: Colors.white,
  },
  formControl: {
    margin: theme.spacing(2),
    minWidth: 120,
  },
  label: {
    color: Colors.lightGrey,
  },
  icon: {
    color: Colors.lightGrey,
  },
  underline: {
    borderBottom: `1px solid ${Colors.lightGrey}`,
    color: Colors.black,
  },
  select: {
    '& .MuiSelect-select:focus': {
      background: 'transparent',
    },
  },
  lightInput: {
    '& .MuiInputBase-input': {
      color: Colors.black,
    },
  },
}));

const NameDropdown = (props) => {
  let { data, type, defaultCompanyId, onSelect, isDistributor, isLight } = props;
  const classes = useStyles();
  if (data.length === 1) {
    if (data[0] === null) {
      data = [];
    }
  };
  
  const handleChange = (event) => {
    onSelect(event.target.value);
  };
  return (
    <StyledNameDropdown className="NameDropDownRowContainer">
      {/* here should come the company avatar */}
      <form className={classes.formContainer} autoComplete="off">
        <FormControl className={clsx(classes.formControl, isLight && classes.lightInput)}>
          <InputLabel className={classes.label} htmlFor={type}>
            {type}
          </InputLabel>
          <Select
            disabled={props.disabled}
            className={classes.select}
            classes={{ icon: classes.icon }}
            style={{ width: Metrics.sideBarDropdownWidth }}
            value={props.data.length > 0 ? defaultCompanyId : 'noCustomer'}
            onChange={handleChange}
            IconComponent={props.disabled ? SvgIcon : ExpandMoreIcon}
            input={
              <Input
                classes={{
                  underline: classes.underline,
                }}
              />
            }
          >
            {data.length === 0 || data[0] === null || data[0] === undefined ? (
              <MenuItem key="0" value={'noCustomer'}>
                {props.noEntry}
              </MenuItem>
            ) : (
              data.map((entry, index) => {
                return (
                  <MenuItem
                    key={isDistributor ? `${entry?.distributorId}-${index}` : `${entry?.customerId}-${index}`}
                    value={isDistributor ? entry?.distributorIdSub : entry?.customerIdSub}
                  >
                    {entry?.distributorName ||
                      entry?.customerName ||
                      entry?.address.fullName ||
                      entry?.address.firstName ||
                      props.noEntry}
                  </MenuItem>
                );
              })
            )}
          </Select>
        </FormControl>
      </form>
    </StyledNameDropdown>
  );
};

export default NameDropdown;
